import { render, staticRenderFns } from "./LowVersion.vue?vue&type=template&id=f9e872c4&scoped=true&"
import script from "./LowVersion.vue?vue&type=script&lang=ts&"
export * from "./LowVersion.vue?vue&type=script&lang=ts&"
import style0 from "./LowVersion.vue?vue&type=style&index=0&id=f9e872c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e872c4",
  null
  
)

export default component.exports